import { Box, Chip, ChipProps, Stack, Typography } from "@mui/material";
import { FC } from "react";

import CachedIcon from "@mui/icons-material/Cached";
import CheckIcon from "@mui/icons-material/Check";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { IngestProcessingState } from "../../../../Core/Api/Types/ingest-processing-state";
import { useTranslation } from "react-i18next";

export type IngestStatusProps = {
  small?: boolean;
  outlined?: boolean;
  status: IngestProcessingState;
  fileSize?: number;
  disabled?: boolean;
  cloud?: boolean;
};

const IngestStatusChip: FC<IngestStatusProps> = (props) => {
  const { t } = useTranslation();
  const { status, fileSize, outlined = true, small = false, cloud = false, ...otherProps } = props;
  let color: ChipProps["color"];
  let label: any = "";
  let icon;

  switch (status) {
    case IngestProcessingState.FileReceived:
    case IngestProcessingState.FileUploading:
      color = "primary";
      icon = <CachedIcon fontSize="small" />;
      label = (
        <Stack spacing={0.5}>
          <Box>{t("common:uploading")}</Box>
          <Typography>{fileSize !== undefined ? fileSize.toFixed(1) : "0"} MB</Typography>
        </Stack>
      );
      break;
    case IngestProcessingState.FileUploadStuck:
    case IngestProcessingState.FileProcessingError:
      if (!cloud) {
        color = "warning";
        icon = <ErrorOutlineIcon fontSize="small" />;
        label = t("chip:label.stuckedOrError");
      } else {
        color = "primary";
        icon = <CachedIcon fontSize="small" />;
        label = t("common:uploading");
      }
      break;
    case IngestProcessingState.FileRejected:
      color = "error";
      icon = <ErrorOutlineIcon fontSize="small" />;
      label = t("common:rejected");
      break;
    case IngestProcessingState.FileMissing:
      color = "info";
      icon = <CheckIcon fontSize="small" />;
      label = t("common:pending");
      break;
    default:
      color = "default";
      icon = <HourglassEmptyIcon fontSize="small" />;
      label = status;
      break;
  }

  if (props.disabled) {
    color = "default";
  }

  return (
    <Chip
      size={small ? "small" : "medium"}
      variant={outlined ? "outlined" : "filled"}
      label={label}
      color={color}
      icon={icon}
      sx={{
        height: "auto",
        p: 0.5,
      }}
    />
  );
};

export default IngestStatusChip;
